import * as THREE from "three";

const createCanvas = (w, h) => {
    const canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d');

    // document.body.prepend(ctx.canvas);

    canvas.width = w ? w : 64;
    canvas.height = h ? h : 64;
    ctx.lineWidth = 1;
    ctx.strokeStyle = '#ff0000';
    return {canvas, ctx}
}

export function createCircleTexture(size, isHollow, lineWidth, color){
    const {canvas, ctx} = createCanvas(size, size);

    ctx.beginPath();
    ctx.lineWidth = lineWidth ? lineWidth : 5
    ctx.strokeStyle = color ? color : ctx.strokeStyle
    ctx.fillStyle = color ? color : ctx.fillStyle
    ctx.arc(canvas.width/2, canvas.height/2, Math.min(canvas.width, canvas.height) / 2 - ctx.lineWidth, 0, 2 * Math.PI);

    isHollow ? ctx.stroke() : ctx.fill();

    return new THREE.CanvasTexture(canvas);
}

export function createRectTexture(width, height){
    const {canvas, ctx} = createCanvas(width, height);
    ctx.strokeRect(2.5, 2.5, canvas.width - 4, canvas.height - 4);
    return new THREE.CanvasTexture(canvas);
}

export function createRandomDotTexture(){
    const ctx = document.createElement('canvas').getContext('2d');
    document.body.prepend(ctx.canvas);
    ctx.canvas.width = 256;
    ctx.canvas.height = 256;
    ctx.fillStyle = '#FFF';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    function randInt(min, max) {
        if (max === undefined) {
            max = min;
            min = 0;
        }
        return Math.random() * (max - min) + min | 0;
    }

    function drawRandomDot() {
        ctx.fillStyle = `#${randInt(0x1000000).toString(16).padStart(6, '0')}`;
        ctx.beginPath();

        const x = randInt(256);
        const y = randInt(256);
        const radius = randInt(10, 64);
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fill();
    }

    function render() {
        drawRandomDot();
        requestAnimationFrame(render);
    }
    requestAnimationFrame(render);

    return new THREE.CanvasTexture(ctx.canvas);
}